import Index from '@/views/settings/Index'
import OrganizationIndex from '@/views/settings/Organization'
import ExportStatsMappingIndex from '@/views/exportStatsMapping/Index'
import ConnectedAccountsIndex from '@/views/connectedAccounts/Index'
import Branding from '@/views/settings/Branding'
import WebsiteMetadata from '@/views/settings/WebsiteMetadata'
import DocumentsIndex from '@/views/documents/Index'
import AboutUs from '@/views/settings/AboutUs'
export default [
  {
    path: ':clientId/settings',
    component: Index,
    children: [
      {
        path: '',
        redirect: { name: 'settings.index' }
      },
      {
        path: 'organization',
        name: 'settings.index',
        component: OrganizationIndex
      },
      {
        path: 'branding',
        name: 'branding.index',
        component: Branding
      },
      {
        path: 'documents',
        name: 'documents.index',
        component: DocumentsIndex
      },
      {
        path: 'website-metadata',
        name: 'websiteMetadata.index',
        component: WebsiteMetadata
      },
      {
        path: 'export-fields-mappings',
        name: 'export-stats-mapping.index',
        component: ExportStatsMappingIndex
      },
      {
        path: 'about-us',
        name: 'about-us.index',
        component: AboutUs
      }
    ]
  },
  {
    path: ':clientId/settings/connected-accounts',
    name: 'connected-account.index',
    component: ConnectedAccountsIndex
  }
]
